<template>
  <div>
    <div class="tenant_title">
      房源查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="输入查询：">
        <el-input
          v-model="formInline.searchValue"
          placeholder="请输入客户姓名/地址/电话"
          clearable
        ></el-input>
      </el-form-item>
      <!-- 选择时间 -->
      <el-form-item label="时间检索：" class="left_margin">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="daterange"
          size="small"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          prefix-icon="el-icon-date"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="房型查询：" class="left_margin">
        <el-select
          v-model="formInline.roomNumber"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in roomNumber"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="房源类型：" class="left_margin">
        <el-select
          v-model="formInline.houseType"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in houseType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> </el-form-item
      ><br />
      <el-form-item label="金额查询：" class="money">
        <el-input
          v-model="money.moneyMin"
          placeholder="最低价"
          clearable
        ></el-input>
        <div class="zhi">至</div>
        <el-input
          v-model="money.moneyMax"
          placeholder="最高价"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="所属公司：" class="left_margin">
        <el-select v-model="formInline.company" clearable placeholder="请选择">
          <el-option
            v-for="item in company"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="left_margin">
        <el-button type="primary" @click="LandlordAjaxList" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
        <!-- <el-button
          type="primary"
          class="newBtn"
          @click="newBtn"
          v-if="premission('New:Listing')"
          >新建</el-button
        > -->
        <el-button type="primary" class="mapBtn" @click="switchBtn"
          >列表模式</el-button
        >
      </el-form-item>
    </el-form>
    <!-- <div class="newly_built">
      <el-button
        type="primary"
        class="export"
        @click="export_btn"
        v-if="premission('Distribution:Operations:Manager')"
        >分配</el-button
      >
      <el-button
        type="primary"
        class="educe"
        v-if="premission('Export:Listing:list')"
        >导出</el-button
      >
    </div> -->
    <!-- Tabs切换 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部房源" name="10"></el-tab-pane>
      <el-tab-pane label="待上线房源" name="1"></el-tab-pane>
      <el-tab-pane label="已上线房源" name="2"></el-tab-pane>
      <el-tab-pane label="已下架房源" name="3"></el-tab-pane>
    </el-tabs>
    <!-- 表单区域 -->

    <div class="MapBox">
      <baidu-map
        class="map"
        :center="centerCity"
        :scroll-wheel-zoom="true"
        :zoom="zoom"
        @zoomstart="syncCenterAndZoom"
        @moveend="moveendAndZoom"
      >
        <bml-marker-clusterer :averageCenter="true">
          <bm-label
            :massClear="true"
            class="bmap"
            id="bmap"
            v-for="(item, index) in tableData"
            :key="index"
            :content="'￥' + item.mDailyPrice"
            :position="{ lng: item.longtitude, lat: item.latitude }"
            :labelStyle="houseIndex == item.houseId ? labelcss : labelcss2"
            @click="houseList(item)"
            :offset="{ width: 0, height: 0 }"
          />
          <!-- <bm-marker
            v-for="(item, index) in tableData"
            :key="index"
            :content="'￥' + item.mDailyPrice"
            :position="{ lng: item.longtitude, lat: item.latitude }"
            :styles="houseIndex == index ? labelcss : labelcss2"
            @click="houseList(index)"
              @mouseover="changeFlag(item.houseId)"
            @mouseout="changeFlagOut()"
            :offset="{ width: 0, height: 0 }"
          ></bm-marker> -->
        </bml-marker-clusterer>
        <!-- <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
        ></bm-geolocation> -->
        <!-- <bml-marker-clusterer :averageCenter="true">
          <bm-marker
            v-for="(marker, index) in markers"
            :key="index"
            :position="{ lng: marker.lng, lat: marker.lat }"
          ></bm-marker>
        </bml-marker-clusterer> -->
        <!-- <bm-label
          :massClear="true"
          class="bmap"
          id="bmap"
          v-for="(item, index) in tableData"
          :key="index"
          :content="'￥' + item.mDailyPrice"
          :position="{ lng: item.longtitude, lat: item.latitude }"
          :labelStyle="houseIndex == index ? labelcss : labelcss2"
          @click="houseList(index)"
          @mouseover="changeFlag(index)"
          @mouseout="changeFlagOut()"
          :offset="{ width: 0, height: 0 }"
        /> -->
      </baidu-map>
      <div class="MapHouseList" v-if="6 < otherZoom && otherZoom <= 15">
        <div
          v-for="item in hourselist"
          :key="item.houseFavour.houseId"
          :class="[
            'HouseBoxList',
            item.houseFavour.houseId == houseIndex ? 'bgc' : ''
          ]"
          @click="HouseBoxListBtn(item)"
        >
          <div class="BoxListImg">
            <img :src="item.houseInfoSon.vCoverPic" alt="" />
          </div>
          <div class="HouseInfo">
            <div class="HouseInfoTitle">{{ item.vHousTitle }}</div>
            <div class="HouseRoom">
              <span v-if="item.roomNumber">{{ item.roomNumber }}室·</span
              ><span v-if="item.hallNumber">{{ item.hallNumber }}厅·</span
              ><span v-if="item.kitchenNumber">{{ item.kitchenNumber }}厨·</span
              ><span v-if="item.bathroomNumber"
                >{{ item.bathroomNumber }}卫</span
              >
              <div class="Price">￥{{ item.houseFavour.mDailyPrice }}/晚</div>
            </div>
            <div class="HouseSize">
              {{ item.address }}
            </div>
          </div>
        </div>
        <div class="Housepagin">
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="CityList" v-if="6 >= otherZoom">
        <el-tree
          :data="CityList"
          :props="defaultProps"
          @node-click="handleNodeClick"
        ></el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import { BmlMarkerClusterer } from "vue-baidu-map";
import { money } from "../../utils/treating";
import JSONbig from "json-bigint";
import {
  hourselistMap,
  hourselistCity,
  LandlordTreeselectListsAjax,
  selectHourseLoadlist,
  hourselist,
  UserListsAjax,
  manySteward
} from "../../api/index";
import premission from "../../utils/permission";
export default {
  mixins: [premission],
  filters: {
    phone: function(item) {
      if (item == null) return;
      return item.substr(0, 3) + "****" + item.substr(7);
    }
  },
  data() {
    return {
      lng: "",
      lat: "",
      centerCity: "中国",
      cityValue: {},
      hourselist: [],
      CityList: [],
      switchBtnNum: "1",

      defaultProps: {
        children: "data",
        label: "province"
      },
      houseIndex: "",
      zoom: 5,
      otherZoom: 5,
      labelcss: {
        // width: "100px",
        // height: "42px",
        color: "#FFF",
        fontSize: "12px",
        border: "1px solid #F6B439",
        borderRadius: "4px",
        backgroundColor: "#F6B439"
      },
      labelcss2: {
        // width: "100px",
        // height: "42px",
        color: "#FFF",
        fontSize: "12px",
        border: "1px solid #219653",
        borderRadius: "4px",
        backgroundColor: "#219653"
      },
      markers: [],
      throttle: true,
      cSteward: "",
      cStewardId: "",
      Inline: {
        pageNum: 1,
        pageSize: 30,
        userName: "",
        deptPost: "",
        deptId: "100"
      },
      checkListPostList: "", //获取的管家id
      data: [],
      dynamicTagsOne: "",
      checkListPost: [],
      LandlordList: [],
      exportList: {
        houseIds: [],
        cStewardId: "", //管家id
        cHouSteward: "" //管家姓名
      },
      // 时间
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      addtitleList: "选择部门",
      // 客户id
      customerId: "",
      // 单选
      radio: "",
      // 搜索
      searchValue: "",
      // 新建弹窗
      dialogVisible: false,
      dialogVisible_export: false,
      // 房东列表
      // defaultProps: {
      //   children: "children",
      //   label: "label"
      // },
      HourseLoadlist: [],
      deptOptions: [],
      total: 0,
      currentPage: 1,
      // 消费金额
      money: {
        moneyMin: "",
        moneyMax: ""
      },
      // 搜索条件
      time: [],
      iHourseStatus: "2", //已下架 1：待上线 2：已上线 3：待审核
      formInline: {
        company: "",
        houseType: "",
        roomNumber: "",
        pageNum: 1,
        pageSize: 5,
        searchValue: undefined
      },
      srcList: [],
      tableData: [],
      company: [],
      roomNumber: [
        {
          value: 1,
          label: "1室"
        },
        {
          value: 2,
          label: "2室"
        },
        {
          value: 3,
          label: "3室"
        },
        {
          value: 4,
          label: "4室"
        },
        {
          value: 5,
          label: "5室"
        },
        {
          value: 6,
          label: "6室"
        },
        {
          value: 7,
          label: "7室"
        },
        {
          value: 8,
          label: "8+室"
        }
      ],

      houseType: [
        {
          value: 0,
          label: "个人房东"
        },
        {
          value: 1,
          label: "悠家自营房东"
        }
      ],
      activeName: "2"
    };
  },
  components: {
    BmlMarkerClusterer
  },
  created() {
    this.LandlordAjaxList();
    this.hourselistCityAjax();
    this.hourselistGet();
    // this.getTreeselectListsAjax();
  },
  methods: {
    // 地址逆解析
    gainAddress(cityValue) {
      this.$jsonp("https://api.map.baidu.com/reverse_geocoding/v3/", {
        location: cityValue,
        output: "json",
        ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
      })
        .then(res => {
          console.log(res);
          this.formInline.searchValue = res.result.addressComponent.province;
          this.hourselistGet();
          // this.hourselistCityAjax();
          this.LandlordAjaxList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    moveendAndZoom(e) {
      // console.log(e.target.getCenter().lat, e.target.getCenter().lng);
      var lat = JSONbig.parse(e.target.getCenter().lat);
      var lng = JSONbig.parse(e.target.getCenter().lng);
      console.log(lat, lng);
      this.cityValue = `${JSONbig.parse(lat)},${JSONbig.parse(lng)}`;

      this.gainAddress(this.cityValue);
    },
    // 房源详情列表
    async hourselistGet() {
      const { data: res } = await hourselist(
        money(this.formInline, this.money, this.time, this.iHourseStatus)
      );
      this.hourselist = res.rows;
      this.total = res.total;
    },
    // 地图中的城市列表
    changeFlag(e) {
      this.houseIndex = e;
    },
    changeFlagOut() {
      this.houseIndex = "";
    },
    async hourselistCityAjax() {
      const { data: res } = await hourselistCity(
        money(this.formInline, this.money, this.time, this.iHourseStatus)
      );
      this.CityList = res.data;
    },
    //切换按钮
    switchBtn() {
      this.$emit("switchBtnNum", this.switchBtnNum);
    },
    // 城市列表点击事件
    handleNodeClick(data) {
      this.centerCity = data.provinces;
      this.zoom = 10;
    },
    syncCenterAndZoom(e) {
      // this.zoom = e.target.getZoom();
      console.log(e.target.getZoom());
      this.otherZoom = e.target.getZoom();
      // if (5 < e.target.getZoom() && e.target.getZoom() <= 10) {
      // }
      // if (10 < e.target.getZoom() && e.target.getZoom() <= 15) {
      // }
    },
    // 点击事件
    houseList(e) {
      // console.log(e);
      var lat = e.latitude;
      var lng = e.longtitude;
      this.zoom = 10;
      this.houseIndex = e.houseId;
      this.$jsonp("https://api.map.baidu.com/reverse_geocoding/v3/", {
        location: `${lat},${lng}`,
        output: "json",
        ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
      })
        .then(res => {
          console.log(res);
          this.centerCity = res.result.addressComponent.province;
        })
        .catch(err => {
          console.log(err);
        });
    },
    HouseBoxListBtn(e) {
      console.log(e);
      this.houseIndex = e.houseFavour.houseId;
    },
    handler({ BMap, map }) {},
    //获取树形结构数据
    // async getTreeselectListsAjax() {
    //   const { data: res } = await LandlordTreeselectListsAjax({
    //     parentId: 138
    //   });
    //   if (res.code !== 200)
    //     return this.$message({
    //       message: res.msg,
    //       type: "error"
    //     });
    //   this.data = res.data;
    // },
    // async newBtn() {
    //   this.dialogVisible = true;
    //   const { data: res } = await selectHourseLoadlist();
    //   if (res.code !== 200) {
    //     return this.$message({
    //       message: res.msg,
    //       type: "error"
    //     });
    //   }
    //   this.HourseLoadlist = res.rows;
    // },
    cancel() {
      this.dynamicTagsOne = "";
      this.checkListPost = [];
      this.exportList = {
        houseIds: [],
        cStewardId: "", //管家id
        cHouSteward: "" //管家姓名
      };
      this.dialogVisible = false;
      this.dialogVisible_export = false;
    },

    reset() {
      this.formInline = {
        company: "",
        houseType: "",
        roomNumber: "",
        pageNum: 1,
        pageSize: 5,
        searchValue: undefined
      };
      this.iHourseStatus = "2";
      this.time = [];
      this.money = {
        moneyMin: "",
        moneyMax: ""
      };
      this.LandlordAjaxList();
    },
    // 获取城市列表数据数据
    async LandlordAjaxList() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await hourselistMap(
        money(this.formInline, this.money, this.time, this.iHourseStatus)
      );
      // console.log(res);
      console.log(res.data, "wu");
      this.throttle = true;
      this.$nextTick(() => {
        this.tableData = res.data;
        console.log(this.tableData);
      });
    },
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.hourselistGet();
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.hourselistGet();
    },

    getImg(row) {
      console.log(row.houseInfoSon.vCoverPic[0]);
      this.srcList = [];
      this.srcList.push(row.houseInfoSon.vCoverPics);
    },

    changeRadio(e) {
      this.cSteward = e.cSteward;
      this.cStewardId = e.cStewardId;
      this.customerId = e.customerId;
    },
    goRental() {
      if (this.customerId == "") return;
      this.$router.push({
        name: "rental", //跳转的路径
        query: {
          customerId: this.customerId,
          cStewardId: this.cStewardId,
          cSteward: this.cSteward
        }
      });
    },
    handleClick(tab) {
      this.formInline.pageNum = 1;
      this.iHourseStatus = tab.name;
      this.LandlordAjaxList();
    },
    // 分配
    // export_btn() {
    //   this.dialogVisible_export = true;
    // },
    // 新增树形
    handleNodeClickTwo(data) {
      this.Inline = {
        pageNum: 1,
        pageSize: 30,
        userName: "",
        deptPost: "",
        deptId: "100"
      };
      this.Inline.deptId = data.id;
      this.onSubmit();
    },
    async onSubmit() {
      const { data: res } = await UserListsAjax(this.Inline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.LandlordList = res.rows;
    }
  }
};
</script>

<style lang="less" scoped>
.tenant_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 220px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
    .newBtn {
      width: 72px;
      height: 36px;
      background-color: #219653;
      border: 1px solid #219653;
    }
    .reset {
      width: 72px;
      height: 36px;
      background-color: #f6b439;
      border: 1px solid #f6b439;
    }
    .mapBtn {
      width: 96px;
      height: 36px;
      background-color: #2f80ed;
      border: 1px solid #2f80ed;
    }
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    // width: 72px;
    height: 36px;
  }
}
/deep/.el-range-separator {
  width: 10%;
}
/deep/.el-range-editor.el-input__inner {
  float: left;
  margin-top: 2px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 80px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .educe {
    background-color: #2f80ed;
    border: #2f80ed;
    width: 72px;
  }
  .export {
    background-color: #f6b439;
    border: #f6b439;
    width: 72px;
  }
  .el-button {
    text-align: center;
    padding: 0;
    height: 36px;
    margin-right: 14px;
  }
}
.money {
  margin-left: 26px;
  /deep/.el-form-item__content {
    width: 244px;
    padding-top: 3px;
  }
  div {
    float: left;
  }
  .zhi {
    width: 44px;
    text-align: center;
  }
  /deep/.el-input {
    width: 100px;
  }
  /deep/.el-input__inner {
    padding-left: 25px;
    float: left;
    width: 100px;
    height: 36px;
  }
}
.checkBox {
  width: 100%;
  height: 50px;
  background: #f2f2f2;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 0px;
}
.el-form-item:nth-last-child(3) {
  margin-left: 0;
}
.paging {
  margin-top: 40px;
  margin-left: 610px;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f6b439;
}
.QuickMark {
  width: 50px;
  height: 36px;
}
.terrace {
  margin-left: 124px;
  height: 40px;
  margin-bottom: 15px;
  .terrace_left,
  .terrace_center,
  .terrace_right {
    font-size: 14px;
    line-height: 40px;
    float: left;
  }
  .terrace_left {
    img {
      width: 40px;
      height: 40px;
    }
    margin-right: 71px;
  }
  .terrace_center {
    margin-right: 47px;
  }
}
.terrace_title {
  margin-top: 10px;
  margin-left: 124px;
  height: 40px;
  .terrace_title {
    float: left;
    line-height: 40px;
  }
}
/deep/.el-table__expanded-cell {
  padding: 15px 50px;
}
.dialog-footer {
  .add_new_btn {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background-color: #f6b439;
    border: 1px solid #f6b439;
    box-sizing: border-box;
    border-radius: 4px;
  }
  .cancel {
    width: 72px;
    height: 36px;
    background-color: #f2f2f2;
    border: 1px solid #e1e1e1;
    box-sizing: border-box;
    border-radius: 4px;
  }
}
.el-dialog__header {
  padding: 30px;
  font-size: 20px;
}
/deep/.el-dialog__body {
  padding: 30px 60px;
}
/deep/.el-dialog__footer {
  padding: 10px 60px 44px;
}
.landlord {
  max-height: 520px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 50px;
  .landlord_title {
    display: flex;
    height: 40px;
    justify-content: space-between;
    border-bottom: 1px solid #e1e1e1;
  }
  .title_list {
    height: 60px;
    line-height: 60px;
    position: relative;
    border-bottom: 1px solid #e1e1e1;
    .list {
      position: absolute;
      left: 0;
    }
    .list:nth-child(2) {
      left: 183px;
    }
    .list:nth-child(3) {
      left: 378px;
    }
    .list:nth-child(4) {
      left: 558px;
      width: 80px;
    }
  }
}
/deep/.el-tabs__active-bar {
  background-color: #f6b439;
}
/deep/.el-tabs__item.is-active {
  color: #f6b439;
}
/deep/.el-tabs__item:hover {
  color: #f6b439;
}
.AddLabel {
  width: 540px;
  min-height: 42px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  margin-bottom: 24px;
  .el-tag.el-tag--warning {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }
}
.select_list_tree {
  overflow: hidden;
  width: 540px;
  padding: 20px 30px;
  border: 1px solid #e1e1e1;
  .treeList {
    float: left;
    width: 280px;
  }
  .select_list_checkBox {
    padding: 0 50px 0 30px;
    float: right;
    width: 198px;
    border-left: 1px solid #e1e1e1;
    .select_list_checkBox_list {
      width: 100%;
      height: 32px;
    }
  }
}
.cancel {
  width: 72px;
  height: 36px;
  background-color: #f2f2f2;
  border: 1px solid #e1e1e1;
  box-sizing: border-box;
  border-radius: 4px;
}
.success_Btn {
  margin-left: 24px;
  width: 72px;
  height: 36px;
  background-color: #f6b439;
  border: 1px solid #f6b439;
  box-sizing: border-box;
  border-radius: 4px;
}
// 地图区域
.MapBox {
  position: relative;
  width: 100%;
  height: 830px;
  .map {
    width: 100%;
    height: 100%;
  }
  .MapHouseList {
    position: absolute;
    padding: 15px;
    left: 0;
    top: 0px;
    width: 470px;
    height: 100%;
    overflow-y: auto;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    background-color: #fff;
    .HouseBoxList {
      cursor: pointer;
      width: 100%;
      height: 130px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
      padding: 15px;
      display: flex;
      .BoxListImg {
        overflow: hidden;
        border-radius: 5px;
        width: 160px;
        height: 100px;
        flex: none;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .HouseInfo {
        flex: 1;
        height: 100px;
        width: 226px;
        padding-left: 10px;
        .HouseInfoTitle {
          width: 100%;
          color: #000000;
          font-size: 18px;
          line-height: 25px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .HouseRoom {
          margin: 8px 0;
          font-size: 14px;
          line-height: 20px;
          color: #666666;
          .Price {
            float: right;
            margin-right: 40px;
            color: #f62a2a;
          }
          .HouseSize {
            line-height: 25px;
          }
        }
      }
    }
    .bgc {
      background-color: #f6b439;
    }
    .HouseBoxList:hover {
      background-color: #f6b439;
    }
  }
  .CityList {
    position: absolute;
    padding: 44px 60px;
    // padding-top:;
    overflow-y: auto;
    top: 20px;
    left: 20px;
    width: 320px;
    height: 785px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  }
  /deep/.bmap {
    background-color: #fff;
  }
}
</style>
